(async () => {
  if (!customElements.get('trustpilot-reviews')) {
    const { default: Swiper, A11y, Navigation, Grid } = await import('swiper');

    Swiper.use([A11y, Navigation, Grid]);
    class TrustpilotReviews extends HTMLElement {
      constructor() {
        super();

        const starSvg = `<svg class="icon icon--star w-full" viewBox="0 0 16 16" fill="none">
        <path d="M11.8378 15.3828C12.0526 15.5 12.2773 15.5293 12.5116 15.4707C12.746 15.4121 12.9267 15.2802 13.0536 15.0752C13.1806 14.8701 13.2245 14.6504 13.1855 14.416V14.416L12.453 10.1387L15.5585 7.12108C15.7343 6.9453 15.827 6.74022 15.8368 6.50585C15.8466 6.27147 15.7782 6.05663 15.6317 5.86132C15.4852 5.666 15.2851 5.54882 15.0311 5.50975V5.50975L10.7538 4.89452L8.84952 1.02734C8.73234 0.792968 8.56144 0.636719 8.33683 0.558594C8.11222 0.480469 7.88761 0.480469 7.663 0.558594C7.4384 0.636719 7.2675 0.792968 7.15031 1.02734V1.02734L5.24602 4.89452L0.968687 5.50975C0.714781 5.54882 0.514586 5.666 0.368102 5.86132C0.221618 6.05663 0.153259 6.27147 0.163025 6.50585C0.17279 6.74022 0.265564 6.9453 0.441344 7.12108V7.12108L3.5468 10.1387L2.81439 14.416C2.77532 14.6504 2.81927 14.8701 2.94622 15.0752C3.07317 15.2802 3.25384 15.4121 3.48821 15.4707C3.72259 15.5293 3.94719 15.5 4.16204 15.3828V15.3828L7.99992 13.3906L11.8378 15.3828Z" fill="#271919"/>
        </svg>
        `;
        const halfStarSvg = `<svg class="icon icon--star w-full" viewBox="0 0 16 16" fill="none">
        <path opacity="0.3" d="M11.6757 14.8828C11.8905 15 12.1151 15.0293 12.3495 14.9707C12.5839 14.9121 12.7646 14.7802 12.8915 14.5752C13.0185 14.3701 13.0624 14.1504 13.0233 13.916V13.916L12.2909 9.63865L15.3964 6.62108C15.5722 6.4453 15.6649 6.24022 15.6747 6.00585C15.6845 5.77147 15.6161 5.55663 15.4696 5.36132C15.3231 5.166 15.1229 5.04882 14.869 5.00975V5.00975L10.5917 4.39452L8.68742 0.527343C8.57023 0.292968 8.39933 0.136719 8.17472 0.0585937C7.95011 -0.0195312 7.7255 -0.0195312 7.5009 0.0585937C7.27629 0.136719 7.10539 0.292968 6.9882 0.527343V0.527343L5.08391 4.39452L0.806577 5.00975C0.552672 5.04882 0.352477 5.166 0.205993 5.36132C0.0595091 5.55663 -0.00884995 5.77147 0.0009155 6.00585C0.010681 6.24022 0.103454 6.4453 0.279235 6.62108V6.62108L3.3847 9.63865L2.65228 13.916C2.61321 14.1504 2.65716 14.3701 2.78411 14.5752C2.91106 14.7802 3.09173 14.9121 3.3261 14.9707C3.56048 15.0293 3.78509 15 3.99993 14.8828V14.8828L7.83781 12.8906L11.6757 14.8828Z" fill="#271919" fill-opacity="0.3"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.83854 2.77811e-07C7.72599 -8.49642e-05 7.61344 0.0194462 7.5009 0.0585937C7.27629 0.136719 7.10539 0.292968 6.9882 0.527343L5.08391 4.39452L0.806577 5.00975C0.552672 5.04882 0.352477 5.166 0.205993 5.36132C0.0595091 5.55663 -0.00884995 5.77147 0.000915501 6.00584C0.010681 6.24022 0.103454 6.4453 0.279235 6.62108L3.3847 9.63865L2.65228 13.916C2.61321 14.1504 2.65716 14.3701 2.78411 14.5752C2.91106 14.7802 3.09173 14.9121 3.3261 14.9707C3.56048 15.0293 3.78509 15 3.99993 14.8828L7.83781 12.8906L7.83854 12.891V2.77811e-07Z" fill="#271919"/>
        </svg>`;

        this.starElement = `<span class="star">${starSvg}</span>`;
        this.starElementHalf = `<span class="star">${halfStarSvg}</span>`;

        this.apiKey = window.trustpilot.api_key;
        this.buid = window.trustpilot.business_unit_id;
        this.baseUrl = `https://api.trustpilot.com/v1/business-units/${this.buid}`;
        this.lang = window.trustpilot.language;
        this.reviewsScore = window.trustpilot.reviews_score;

        this.starsParameter = '';

        if (this.reviewsScore !== '') {
          this.starsParameter = `&stars=${this.reviewsScore}`;
        }

        this.skuParameter = '&sku=';

        this.sku = this.dataset.productSku;
        if (this.sku) {
          this.skuParameter = `&sku=${this.sku}`;
        }

        this.getLocale();

        this.starsContainer = this.querySelector('[data-tp-stars]');

        this.fetchGeneralProductData();
        this.tpImage();
        this.fetchLinkToAll();
      }

      connectedCallback() {
        this.observer = new IntersectionObserver(this.handleIntersection);
        this.observer.observe(this);
      }

      handleIntersection(entries, observer) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const reviews = [];
            entry.target.querySelectorAll('.swiper-slide').forEach((review, index) => {
              if (review.offsetParent !== null) {
                reviews.push({
                  title: review.firstElementChild.textContent.trim(),
                  position: index + 1,
                  score: review.querySelector('[data-review-stars]')?.children.length || null,
                });
              }
            });
            const totalScore = entry.target
              .querySelector('.trustpilot-reviews__stars')
              .textContent.trim();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'ReviewSection',
              pageType:
                document.querySelector('[data-template-class]').dataset.templateClass ||
                'undefined',
              pageURL: window.location.href || 'undefined',
              totalScore: totalScore,
              reviewType: this.sku ? 'Product' : 'Company',
              reviews: reviews,
            });
            debug() && console.log('ReviewSection: ', reviews, window.dataLayer);
            observer.unobserve(entry.target);
          }
        });
      }

      getLocale() {
        this.locale = `${this.lang}-${this.lang}`;
      }

      fetchLinkToAll() {
        fetch(`${this.baseUrl}/web-links?apikey=${this.apiKey}&locale=${this.locale}`)
          .then((response) => response.json())
          .then((data) => {
            const profileLink = data.profileUrl;
            const linkContainer = this.querySelectorAll('[data-tp-link]');

            if (linkContainer) {
              linkContainer.forEach((item) => {
                item.href = profileLink;
              });
            }
          });
      }

      initSwiper() {
        this.createSwiper();
        this.handleSwiperButtons();
        window.addEventListener('resize', () => {
          this.handleSwiperButtons();
        });
      }

      createSwiper() {
        this.swiper = this.querySelector('[data-swiper-tp]');

        // Stop when the swiper is not found
        if (!this.swiper) return false;

        // Default to improve user experience
        this.swiperOptions = {
          threshold: 10,
          a11y: true,
        };

        // Check if we have extra options on the HTML
        if (this.swiper.dataset.options) {
          const options = JSON.parse(this.swiper.dataset.options);
          if (options) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...options,
            };
          }
        }

        // Call swiper with selected swiper element and options
        this.swiperInstance = new Swiper(this.swiper, this.swiperOptions);
      }

      handleSwiperButtons() {
        const windowWidth = window.innerWidth;
        if (windowWidth > 480) {
          this.querySelectorAll('button').forEach((button) => button.classList.remove('hidden'));
        } else if (this.swiperInstance) {
          this.querySelectorAll('button').forEach((button) => button.classList.add('hidden'));
        }
      }

      /**
       * Fetch average product score
       */
      async fetchGeneralProductData() {
        try {
          const response = await fetch(
            `https://api.trustpilot.com/v1/product-reviews/business-units/${this.buid}?apikey=${this.apiKey}${this.skuParameter}`
          );
          const json = await response.json();

          this.totalScore = json.starsAverage;
          const isInteger = Number.isInteger(this.totalScore);

          if (this.totalScore === 0) {
            this.fetchGeneralData();
            return;
          } else {
            this.fetchProductReviews();
          }

          if (this.starsContainer) {
            this.renderStars(isInteger, this.totalScore, this.starsContainer, true);
          }
        } catch (error) {
          console.error(error);
        }
      }

      /**
       * Fetch product reviews
       */
      async fetchProductReviews() {
        try {
          const response = await fetch(
            `https://api.trustpilot.com/v1/product-reviews/business-units/${this.buid}/reviews?apikey=${this.apiKey}${this.skuParameter}&language=${this.lang}&perPage=8${this.starsParameter}`
          );
          const json = await response.json();

          const ProductReviewsArr = json.productReviews;

          ProductReviewsArr === 0
            ? this.fetchReviews()
            : this.renderProductReviews(ProductReviewsArr);
        } catch (error) {
          console.error(error);
        }
      }

      renderProductReviews(array) {
        this.reviewsContainer = this.querySelector('[data-swiper-wrapper]');

        array.forEach((review, reviewIndex) => {
          const name = review.consumer.displayName;
          const reviewText = review.content;
          const reviewTitle = review.content;
          const reviewerName = name ? name : 'Anonymous';
          const totalReviewScore = review.stars;

          this.renderReview(reviewTitle, totalReviewScore, reviewText, reviewerName, reviewIndex);
        });

        // Init swiper after the content is ready
        this.initSwiper();
      }

      /**
       * Fetch average brand score
       */
      async fetchGeneralData() {
        try {
          const response = await fetch(`${this.baseUrl}?apikey=${this.apiKey}`);
          const json = await response.json();

          this.totalScore = json.score.trustScore;
          const isInteger = Number.isInteger(this.totalScore);

          this.fetchReviews();

          if (this.starsContainer) {
            this.renderStars(isInteger, this.totalScore, this.starsContainer, true);
          }
        } catch (error) {
          console.error(error);
        }
      }

      /**
       * Fetch brand reviews
       */
      async fetchReviews() {
        try {
          const response = await fetch(
            `${this.baseUrl}/reviews?apikey=${this.apiKey}&perPage=8${this.starsParameter}&language=${this.lang}`
          );
          const json = await response.json();

          const ReviewsArr = json.reviews;

          if (ReviewsArr) {
            this.renderReviews(ReviewsArr);
          }
        } catch (error) {
          console.error(error);
        }
      }

      renderReviews(array) {
        this.reviewsContainer = this.querySelector('[data-swiper-wrapper]');

        array.forEach((review, reviewIndex) => {
          if (review.status === 'active') {
            const name = review.consumer.displayName;
            const reviewText = review.text;
            const reviewTitle = review.title;
            const reviewerName = name ? name : 'Anonymous';
            const totalReviewScore = review.stars;

            this.renderReview(reviewTitle, totalReviewScore, reviewText, reviewerName, reviewIndex);
          }
        });

        // Init swiper after the content is ready
        this.initSwiper();
      }

      renderReview(title, score, text, name, index) {
        const slideContent = `
      <div class="swiper-slide rounded-lg bg-accent-light py-4 px-5 flex flex-col gap-y-2 h-[10.25rem]"
      data-review-index=${index}
      data-swiper-slide-index="${index}"
      >
        <p class="font-body text-base line-clamp-1">${title}</p>
        <div class="flex items-center gap-x-3" data-review-stars>${score}</div>
        <p class="text-xs line-clamp-3">${text}</p>
        <p class="font-body text-xs line-clamp-1">${name}</p>
      </div>
      `;
        if (index === 0) {
          this.reviewsContainer.innerHTML = slideContent;
        } else {
          this.reviewsContainer.innerHTML += slideContent;
        }

        const reviewItem = this.querySelector(`[data-review-index="${index}"]`);
        const scoreContainer = reviewItem.querySelector('[data-review-stars]');
        if (scoreContainer) {
          this.renderStars(true, score, scoreContainer, false); // Always an integer and don't need to render the total score
        }
      }

      async tpImage() {
        try {
          const response = await fetch(
            `https://api.trustpilot.com/v1/resources/images/logos?apikey=${this.apiKey}`
          );
          const json = await response.json();

          const logoContainer = this.querySelector('[data-tp-logo]');
          const tpLogo = new Image(150, 40);
          tpLogo.src = json.lightBackground.logoSvg.url;
          logoContainer.querySelector('svg').remove();
          logoContainer.appendChild(tpLogo);
        } catch (error) {
          console.error(error);
        }
      }

      renderStars(isInteger, starsNumber, container, needsTotal) {
        for (let i = 0; i < Math.trunc(starsNumber); i++) {
          if (i === 0) {
            container.innerHTML = this.starElement;
          } else {
            container.innerHTML += this.starElement;
          }
        }
        if (!isInteger) {
          container.innerHTML += this.starElementHalf;
        }

        if (needsTotal) {
          container.innerHTML += this.totalScore;
        }
      }
    }
    window.TrustpilotReviews = TrustpilotReviews;

    customElements.define('trustpilot-reviews', TrustpilotReviews);
  }
})();
